// src/app/core/interceptors/camel-case-response.interceptor.ts
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { objectPropertiesToCamelCase } from '../../shared/utils/objects-utils';

@Injectable()
export class CamelCaseResponseInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Solo procesar respuestas del backend API
    if (!req.url.startsWith(environment.baseBackendUrl)) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        // Solo transformar respuestas HTTP exitosas
        if (event instanceof HttpResponse) {
          // Transformar el body a camelCase
          const transformedBody = objectPropertiesToCamelCase(event.body);
          return event.clone({ body: transformedBody });
        }
        return event;
      })
    );
  }
}

